// Source/Anchor-Links/mod.ts
document.addEventListener("click", onAnchorClick, {
  capture: true
});
function onAnchorClick(event) {
  let { target } = event;
  if (!target)
    return;
  if (!(target instanceof Element))
    return;
  if (!(target instanceof HTMLAnchorElement)) {
    target = target.closest(`a`);
    if (!target)
      return;
  }
  const { href } = target;
  const there = new URL(href);
  const here = new URL(location.href);
  if (here.host !== there.host)
    return;
  if (here.pathname !== there.pathname)
    return;
  if (there.hash === "")
    return;
  const destination = document.querySelector(there.hash);
  if (!destination)
    return;
  destination.scrollIntoView({
    behavior: "smooth",
    block: "start"
  });
  event.preventDefault();
}
export {
  onAnchorClick
};
